import {BaseFilterRequest} from '../base-filter-request';
import {Stringifier} from '../../../services/stringifier.service';
import {FString} from '../../../services/filters/string-filter';

@Stringifier
export class FilterAclGroupsRequest extends BaseFilterRequest {
    name?: FString | null;
    description?: FString | null;
    users?: FilterUserAclGroupRequest | null;
    permissionName?: FString | null;

    static getStringifier(level: number): FilterAclGroupsRequest | null {
        if (level < 0) {
            return null;
        }
        // @ts-ignore
        return {
            name: null,
            description: null,
            users: FilterUserAclGroupRequest.getStringifier(level - 1),
            permissionName: null,
        } as FilterAclGroupsRequest;
    }
}

@Stringifier
export class FilterUserAclGroupRequest extends BaseFilterRequest {
    user?: FilterUserRequest | null;

    static getStringifier(level: number): FilterUserAclGroupRequest | null {
        if (level < 0) {
            return null;
        }
        // @ts-ignore
        return {
            user: FilterUserRequest.getStringifier(level - 1),
        } as FilterUserAclGroupRequest;
    }
}

@Stringifier
export class FilterUserRequest extends BaseFilterRequest {
    /**
     * Esegue il filtro per codice/nome/cognome
     */
    codice?: FString | null;

    static getStringifier(level: number): FilterUserRequest | null {
        if (level < 0) {
            return null;
        }
        // @ts-ignore
        return {
            codice: null,
        } as FilterUserRequest;
    }
}
